<template>

  <div class="padded">

<!--       :add-action="selectView"  -->

    <data-table
      :title="utilLabel + ' Bills'"
      table-ref="utilbillingtable"
      :url="url"
      :fields="siteFields"
      sort-field="siteName"
      search-placeholder="Site Ids, Site Names, Addresses, Account..."
      :add-props="addProps"
      detail-component="site-util-row"
      @toggled="this.view = !this.view">

      <template slot="bills-slot" slot-scope="props">
        <el-row>
          <el-col :span="12">
            <utility-action button-size="small" :site-data="props.rowData" />
          </el-col>
          <el-col v-if="canAccess('finance')" :span="12">
            <utility-payment-action button-size="small" :site-data="props.rowData" />
          </el-col>
        </el-row>
      </template>

    </data-table>

  </div>

</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import SiteMixins from '@/mixins/SiteMixins'

import UtilityAction from '@/components/actions/UtilityBillAction'
import UtilityPaymentAction from '@/components/actions/UtilityBillPayAction'

import SiteUtilTable from '@/components/sites/utility/SiteUtilTable'

Vue.component('site-util-row', SiteUtilTable)

Vue.use(VueEvents)

export default {
  mixins: [SiteMixins],

  components: {
    UtilityAction,
    UtilityPaymentAction
  },

  props: {
    sharer: {
      type: Number,
      default: null
    }
  },

  watch: {
    sharer: function (value) {
      this.telcoId = value
      this.$refs.sitetable.refresh()
    }
  },

  computed: {
    url: function () {
      return this.view ? '/sites' : '/utility/site/bills'
    }
  },

  data () {
    return {
      view: true,
      selectView: {

        props: {
          toggle: {
            type: Boolean
          }
        },

        methods: {
          check () {
            this.$emit('toggled', this.showBills)
          }
        },

        data () {
          return {
            showAll: this.toggle
          }
        },

        template: `<center>
                    <el-switch v-model="showAll" active-text="All" inactive-text="Bills Only" @change="check" />
                    </center>`
      },

      addProps: {
        toggle: this.view
      },
      utilLabel: this.getUtilLabel(),
      telcoId: this.sharer,
      siteFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          visible: this.isTowerCo(),
          callback: this.formatSiteStatus
        },
        {
          name: 'siteId',
          title: 'Site ID',
          sortField: 'siteId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'siteName',
          title: 'Site Name',
          sortField: 'siteName'
        },
        {
          name: 'tenancy.utilAccount',
          title: this.getUtilLabel() + ' Account #'
        },
        {
          name: 'tenancy.utilLastBill',
          title: 'Last Bill'
        },
        {
          name: '__slot:bills-slot',
          title: ''
        }
      ]
    }
  },

  created () {
    this.addProps.toggle = this.view
  },

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}
</script>
